import { Asset, useUgla3dStateManager } from "@ugla-france/ugla-3d-library";
import React from "react";
import styled from "styled-components";
import { getTag } from "../helpers/getTags";

// Styled components
const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:center;
  gap: 1rem;
  padding: 1rem;
  max-width:45rem;
`;

const CarouselTrack = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 1rem;
  width: 100%;
  max-width: 1000px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const Card = styled.div`
  position: relative;
  min-width: 100px;
  max-width: 150px;
  max-height: 80px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: #fff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  scroll-snap-align: start;
  &:hover {
    transform: scale(0.95);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  &:hover{
    cursor:pointer;
  }
`;

const CardName = styled.div`
    position: absolute;
    bottom: 6rem;
    padding: 1rem;
    font-size: 1.2rem;
    font-weight: bold;
    color: white;
    text-align: center;
`;

interface CarrouselProps {
  items: Asset[];
  onPovChange?: (pov: number) => void;
  onCarouselClick?: () => void;
}


// Carousel component
const Carrousel: React.FC<CarrouselProps> = ({ items, onPovChange, onCarouselClick }) => {
    const stateManager = useUgla3dStateManager();
    const changePov = (asset: Asset) => {
        stateManager.removeObject('main');
        stateManager.addObject({ id: "main", asset: asset });
        
        // Notify parent to hide 360 viewer
        if (onCarouselClick) {
            onCarouselClick();
        }
        
        // Notify parent about POV change
        const povTag = asset.tags?.find((tag) => tag.key === 'pov');
        if (povTag && onPovChange) {
            const povValue = parseInt(povTag.value || '1', 10);
            if (!isNaN(povValue)) {
                onPovChange(povValue);
            }
        }
    };
  return (
    <CarouselContainer>
      <CarouselTrack>
        {items ? items.map((item, index) => (
          <Card key={index} onClick={() => changePov(item)}>
            <CardImage src={item?.url} alt={getTag('name', item.tags)} />
            {/* <CardName>{getTag('name', item.tags)}</CardName> */}
          </Card>
        )) : null}
      </CarouselTrack>
    </CarouselContainer>
  );
};

export default Carrousel;
